export default __webpack_public_path__ + "static/media/espago-screenshot-04.fa28f457.png";